import axios from 'axios';
require('dotenv').config();

axios.defaults.baseURL = process.env.REACT_APP_API_SERVER;
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Content-type'] = 'application/json;charset=UTF-8';

export const setAuthToken = (transactionToken) => {
  axios.defaults.headers.common.Authorization = `Bearer ${transactionToken}`;
};

export const recaptchaKey = process.env.REACT_APP_CAPTCHA_KEY;
export const identity = {
  env: process.env.REACT_APP_ENV,
  identityCode: process.env.REACT_APP_IDENTITY_APP_CODE
};
export const api = (uri) => process.env.REACT_APP_API_SERVER + uri;

export const generateToken = ({ captchaToken }) => axios.post('/signup/v1/account/token', { captchaToken });
export const generatePromotionToken = ({ captchaToken, sessionToken }) => {
  const options = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionToken}` },
    data: { captchaToken },
    url: '/promotion/v1/token'
  };

  return axios(options);
};
export const getAccountList = (govtId) => axios.get(`/signup/v1/account/${govtId}`);
export const availableUserName = (name) => axios.get(`/signup/v1/account/${name}/username`);
export const getRestrictedGames = (authToken) => axios.get(`/signup/v1/account/token/${authToken}/restrictions`);

export const acquirePI = (authToken) => axios.get(`/selfauth/v1/identity/${authToken}`);
export const acquireParentPI = (playerAuthInfo, authToken) =>
  axios.get(
    `/signup/v1/account/token/${encodeURIComponent(playerAuthInfo)}/parent/token/${encodeURIComponent(authToken)}`
  );

/**
 * Email verification
 */
export const verifyEmail = (email) =>
  axios.post('/signup/v1/account/email/code', {
    target: email
  });
export const confirmVerifyEmail = (payload) =>
  axios.put('/signup/v1/account/email/code', {
    ...payload
  });

// Create account /POST
export const createAccount = ({
  username,
  password,
  email,
  parentEmail,
  playerAuthInfo,
  parentAuthInfo,
  marketingAgreement
}) =>
  axios.post('/signup/v1/account', {
    username,
    password,
    email,
    parentEmail,
    playerAuthInfo,
    parentAuthInfo,
    marketingAgreement
  });

// promote account /PUT
export const promoteAccount = ({
  username,
  password,
  email,
  parentEmail,
  playerAuthInfo,
  parentAuthInfo,
  marketingAgreement
}) =>
  axios.put('/signup/v1/account', {
    username,
    password,
    email,
    parentEmail,
    playerAuthInfo,
    parentAuthInfo,
    marketingAgreement
  });
